import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | InspiraPix</title>
        <meta name="description" content="The page you are looking for could not be found." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
          <Link to="/" className="back-home-button">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound; 